var _style, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLogoutOff10 = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 57 50",
    style: {
      enableBackground: "new 0 0 57 50"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.6;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#BCBCBC;}\n\t.st3{fill:#006E95;}\n\t.st4{fill:#5BC8AF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52,23l-4.1-2.4l-4.1-2.4c-1.5-0.9-3.5,0.2-3.5,2v1.4c0,0.3-0.2,0.5-0.5,0.5H23.3c-1.6,0-2.9,1.3-2.9,2.9 c0,1.6,1.3,2.9,2.9,2.9h16.5c0.3,0,0.5,0.2,0.5,0.5v1.4c0,1.8,1.9,2.9,3.5,2l4.1-2.4L52,27C53.5,26.1,53.5,23.9,52,23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M21.3,37.2c-6.7,0-12.2-5.5-12.2-12.2s5.5-12.2,12.2-12.2c5.1,0,9.5,3.1,11.3,7.6h5.5 c-2-7.4-8.8-12.8-16.8-12.8C11.7,7.5,3.9,15.4,3.9,25c0,9.6,7.8,17.5,17.5,17.5c8,0,14.8-5.4,16.8-12.8h-5.5 C30.8,34.1,26.4,37.2,21.3,37.2z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogoutOff10, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Log out_off-10.f2189a58.svg";
export { ForwardRef as ReactComponent };